import { render, staticRenderFns } from "./SocialInformation.vue?vue&type=template&id=7a55906e&scoped=true&"
import script from "./SocialInformation.vue?vue&type=script&lang=js&"
export * from "./SocialInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55906e",
  null
  
)

export default component.exports